import { mapMutations } from 'vuex'

export default {
  data() {
    return {
      rutaPublic: process.env.VUE_APP_API_URL_PLUBLIC,
      nameProject: process.env.VUE_APP_PROJ_NAME,
    }
  },
  mounted() {
    // eslint-disable-next-line no-undef
    this.$echo.channel('chatnotread').listen('.chatnotread', data => {
      this.setChatBotRead(data.data)
    })
  },
  methods: {
    ...mapMutations([
      'setConfigDataGeneral',
    ]),
    async fetchDataFromEndpoints() {
      try {
        const [
          res,
        ] = await Promise.all([
          this.axios.get('configuration-view/data-general'),
        ])

        // CONFIG
        if (res.data.success) {
          const jsonConfig = {
            color: res.data.data.data.data.color,
            favicon: res.data.data.data.data.favicon,
            isotipo: res.data.data.data.data.isotipo,
            logo: res.data.data.data.data.logo,
            name: res.data.data.data.data.name,
          }
          if (res.data.data.data.data.favicon) {
            const favicon = document.getElementById('favicon')
            favicon.href = `${this.rutaPublic}${res.data.data.data.data.favicon}`
          }

          if (res.data.data.data.data.name) {
            const ppp = 'Panel de Administración / '
            document.title = this.nameProject === 'wwwww'
              ? `${ppp}${res.data.data.data.data.name}, plataforma de viajes`
              : `${ppp}${res.data.data.data.data.name}`
          }
          this.setConfigDataGeneral(jsonConfig)
          this.$vuetify.theme.themes.light.primary = res.data.data.data.data.color
          localStorage.setItem('configData', JSON.stringify(jsonConfig))
        }
      } catch (err) {
        console.error('Error fetching data:', err)
      }
    },
  },
  created() {
    this.fetchDataFromEndpoints()
  },
}
